
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'HlButton',

  props: {
    /** 前缀图标 */
    icon: String,
  }
});
